document.documentElement.classList.remove('no-js');
const toggle = document.querySelector('[data-menu-toggle]');
const menu = document.querySelector('[data-menu]');
if (toggle && menu) toggle.addEventListener('click', () => { const open = menu.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', String(open)); });
document.querySelectorAll('[data-sort]').forEach(select => select.addEventListener('change', () => { const url = new URL(window.location.href); url.searchParams.set('sort_by', select.value); window.location.assign(url.toString()); }));
const variant = document.querySelector('[data-variant-select]');
if (variant) variant.addEventListener('change', () => { const option = variant.options[variant.selectedIndex]; const price = document.querySelector('[data-price]'); if (price) price.textContent = option.dataset.price; });

document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const count = gallery.querySelector('[data-gallery-current]');
  let activeIndex = 0;

  const show = index => {
    if (!slides.length) return;
    activeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== activeIndex)));
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === activeIndex);
      thumb.setAttribute('aria-selected', String(i === activeIndex));
    });
    if (count) count.textContent = String(activeIndex + 1);
    thumbs[activeIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  };

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(activeIndex - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(activeIndex + 1));

  let touchStartX = 0;
  const stage = gallery.querySelector('[data-gallery-stage]');
  stage?.addEventListener('touchstart', event => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  stage?.addEventListener('touchend', event => {
    const distance = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(distance) > 45) show(activeIndex + (distance < 0 ? 1 : -1));
  }, { passive: true });
});
